import { Box, Divider, Drawer } from "@mui/material";
import { FC } from "react";
import PatientNote from "../../types/PatientNote";
import NoteCard from "./note-card";
import DrawerHeader from "../drawer-header";

interface NotesDrawerProps {
  open: boolean;
  patientNotes: PatientNote[];
  onNoteDeleted: (id: number) => void;
  onClose: () => void;
}

const NotesDrawer: FC<NotesDrawerProps> = ({
  open,
  patientNotes,
  onNoteDeleted,
  onClose,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => onClose()}
      ModalProps={{
        BackdropProps: { sx: { background: "none" } },
      }}
      slotProps={{
        paper: {
          sx: { maxWidth: "28rem", overflowY: "none" },
        },
      }}
    >
      <Box>
        <DrawerHeader
          title="All Notes"
          subtitle="Viewing notes from the last 7 days."
          onClose={onClose}
        />
        <Divider />
        {patientNotes?.map((note) => (
          <Box key={note.id}>
            <NoteCard
              note={note}
              inDrawer={true}
              onNoteDeleted={onNoteDeleted}
            />
          </Box>
        ))}
      </Box>
    </Drawer>
  );
};

export default NotesDrawer;
